import React, { FC } from "react";
import { Outlet } from "react-router-dom";

import Header from "../Header/Header";
import Footer from "../footer/Footer";

/** Shared chrome for all public pages: sticky header, content, static footer. */
const PublicLayout: FC = () => {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default PublicLayout;
